import { isMixpanelDevMode } from "./mixpanelDevMode";

/*
  Conversions for Google Ads, sent as GA4 events through the gtag snippet in
  index.html (G-VVZ00C9GVY) and imported into Google Ads as key events. They
  sit beside the Mixpanel events for the same moments, which stay the source
  of truth for product analytics.

  Local dev and staging only log them: the gtag snippet loads there too, and
  their events would land in the production property.
*/
const gtagEvent = (event: string, params: Record<string, unknown> = {}) => {
  if (isMixpanelDevMode()) {
    // eslint-disable-next-line no-console
    console.debug(
      `%c[gtag]%c ${event}`,
      "color:#1a73e8;font-weight:bold",
      "color:inherit",
      params,
    );
    return;
  }
  // index.html defines gtag before anything else runs; if a blocker removed
  // it, analytics is optional.
  if (typeof window.gtag !== "function") return;
  window.gtag("event", event, params);
};

/** A new account's first login, by email code or Google. */
export const trackSignupSuccess = () => gtagEvent("signup_success");

/** A club import that came back with a club; blocked and failed ones don't count. */
export const trackClubImportDoneConversion = () =>
  gtagEvent("club_import_done");

/** Stripe checkout completed, any plan. */
export const trackPaymentCompleted = () => gtagEvent("payment_completed");
